import { useMemo } from "react";
import { Grid, Box } from "@mui/material";
import { IconFlagFilled } from "@tabler/icons-react";
import MxDetailSmallCard from "@rf-l1/page/details/MxDetailCardSmall";
import { MxPersonCard } from "@/src-refactor/modules/shared/components/cards/person-card";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import { formatPhoneNumber } from "@/src-refactor/modules/shared/helpers/format-phone-number.helper";
import { redirectEmail } from "@/src-refactor/modules/shared/helpers/email.helper";
import { useNavigate } from "react-router-dom";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";
import { useLoggedUser } from "@/shared/store/auth";
import { MxOwnerCard } from "@/src-refactor/modules/shared/components/cards/person-card/MxPersonCard";
import useUserHelp from "@rf-hooks/useUserHelp";

/**
 * PropertyOwnersCard
 *
 * Tarjeta que muestra los propietarios de la propiedad.
 * Solo visible para agentes captadores, super admins y los propios propietarios.
 */
const PropertyOwnersCard = () => {
  const { owners = [], agents = [] } = usePropertyDetailPage();
  const navigate = useNavigate();
  const { USER_ROLE } = useUserHelp();
  const {
    userLogged: { userData }
  } = useLoggedUser();

  const canViewOwners = useMemo(() => {
    if (USER_ROLE.IS_ADMINISTRATOR) {
      return true;
    }

    const isAgent = agents.some(agent => agent.id === userData?.people_id);
    if (isAgent) {
      return true;
    }
    return false;
  }, [USER_ROLE.IS_ADMINISTRATOR, agents, userData]);

  if (!canViewOwners || !owners || owners.length === 0) {
    return null;
  }

  return (
    <MxDetailSmallCard title="Propietario/s">
      <Grid container direction="column" rowGap={4}>
        {owners.map((owner, index) => (
          <MxOwnerCard
            key={owner.id || index}
            name={owner.name}
            role="Propietario"
            phone={formatPhoneNumber(owner.phone)}
            email={owner.email}
            nameIcon={
              owner.isConflictive && USER_ROLE.IS_ADMINISTRATOR ? (
                <IconFlagFilled />
              ) : undefined
            }
            onNameClick={() => navigate(C_PATH_ROUTES.OWNERS.DETAIL(owner.id))}
            onMessageClick={() => redirectEmail(owner.email)}
          />
        ))}
      </Grid>
    </MxDetailSmallCard>
  );
};

export default PropertyOwnersCard;
